import React from 'react';
import { Popup } from '$/components/ui/Popup';

export const PurchaseTrackingPopup: React.FC = () => {
  return (
    <Popup
      classNameIcon='p-0'
      content={
        <span>
          This piece of code is meant to be embedded directly in your checkout flow’s Thank You
          page, meaning the page that your customers are redirected to after successfully completing
          payment for this offer's product. I should be placed inside the {'<BODY>'} tag of the
          page's HTML.
          <p />
          You'll notice the code contains placeholders such as __AMOUNT__ which you should modify to
          reflect the price amount for each sale. For example, if your product is sold for $29.99,
          you’d replace __AMOUNT__ with 29.99 or depending on your checkout platform they may have a
          dynamic field you can replace it with such as {'{{ total_price }}'} which we have done for
          you automatically if you're using the Thinkific offer card.
          <p />
          For more information please see the{' '}
          <a
            href='https://ewebinar.com/help/how-do-i-track-product-sales-from-offers-made-in-ewebinar'
            target='_blank'
            rel='noopener'
          >
            Tracking your product sales
          </a>{' '}
          help article.
        </span>
      }
      popperModifiers={[
        {
          preventOverflow: {
            enabled: false,
            boundariesElement: 'window',
            escapeWithReference: true,
          },
        },
      ]}
    />
  );
};

export default PurchaseTrackingPopup;
